'use strict';

var module = angular.module('tael.app.observatoire', [
    require("../../modules/common/common-module"),
    require("../../modules/observatoire/observatoire-module")
]);

module.constant('$APP_NAME', 'OBSERVATOIRE');

module.config(function($routeProvider, $locationProvider, $qProvider) {

    $routeProvider
        .otherwise({
            redirectTo: '/communes'
        });

    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');

    //$qProvider.errorOnUnhandledRejections(false);
});

module.config(function(initialisationServiceProvider) {

    /*
    // load user and compte from server
    initialisationServiceProvider.addInitialisationHandler(["$session", "$authz", "$q", function($session, $authz, $q) {
        return $q.when($session.$load()).then(function() {
            return $authz.$setUser($session.getUser(), $session.getHabilitations());
        });
    }]);
    */

    // load translations from server
    initialisationServiceProvider.addInitialisationHandler(["$translate", "indexationService", function($translate) {
        return $translate.init({ url  : "/rest/translations/observatoire", lang : "fr"});
    }]);

    // load currencies
    initialisationServiceProvider.addInitialisationHandler(["currencyService", function(currencyService) {
        return currencyService.$load();
    }]);

    // load application settings
    initialisationServiceProvider.addInitialisationHandler(["applicationSettings", function(applicationSettings) {
        return applicationSettings.$load();
    }]);

});

module.run(function(security, initialisationService) {
    security.initAuthentication();
    initialisationService.executeHandlers();
});


// Warning : do NOT factorize this : webpack will not be able to parse parametrized context paths.
function requireAllInContext(context) {
    context.keys().forEach(context);
}
requireAllInContext(require.context("./ng", true, /\.(js|ts|less|css)$/));
requireAllInContext(require.context("./css", true, /\.(js|ts|less|css)$/));


// WEBPACK FOOTER //
// ./src/apps/observatoire/observatoire-app.js